import React from 'react';
import '../styles/fonts.css';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

function ContactUs() {
    const [submitStatus, setSubmitStatus] = React.useState({
        text: 'Submit',
        color: 'black'
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            message: formData.get('message')
        };

        try {
            const requestBody = {
                to: "shuhada@crescovent.com",
                from: "Sales@crescovent.com",
                subject: "New Contact Inquiry from Cresco Website",
                html: `<div style=\"font-family:Arial,sans-serif;max-width:600px;padding:20px;border:1px solid #ddd;border-radius:5px\"><h2 style=\"background-color:#9b2c2c;color:#fff;padding:10px;text-align:center\">New Inquiry from Cresco Website</h2><p><strong>Name:</strong> ${data.name}</p><p><strong>Phone Number:</strong> ${data.phone}</p><p><strong>Email:</strong> ${data.email}</p><p><strong>Message:</strong></p><p>${data.message}</p><hr><p style=\"font-size:14px;color:#666\">This inquiry was submitted via the Cresco website contact form.</p></div>`
            };

            const response = await fetch('https://sendgrid.sysmio.com/api/mail/send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (response.status === 429) {
                throw new Error('Too many requests. Please wait a moment and try again.');
            }

            if (!response.ok) {
                throw new Error('Failed to send email');
            }

            setSubmitStatus({ text: 'Success!', color: '#28a745' });
            setTimeout(() => {
                setSubmitStatus({ text: 'Submit', color: 'black' });
            }, 3000);
            e.target.reset();
        } catch (error) {
            console.error('Error sending form:', error);
            setSubmitStatus({ text: 'Error - Try Again', color: '#dc3545' });
            setTimeout(() => {
                setSubmitStatus({ text: 'Submit', color: 'black' });
            }, 3000);
        }
    };

    return (
        <div className="overflow-hidden" style={{
            backgroundImage: 'url("/bg.png")',  // Add your background image path
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
        }}>
            {/* Contact Us Section */}
            <div className="container-fluid px-4 px-md-5 py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 mb-md-0 mb-4">
                        <div className="row">
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '60px'
                                }}>
                                Contact Us
                            </h1>
                            <h2 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '36px', fontWeight: 'bold' }}>
                                CRESCO VENTURES SDN BHD
                            </h2>
                            <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                Email, call, or complete the form to let us explore how we can turn your digital vision into reality.
                            </p>
                            <p className="text-start text-muted" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                shuhada@crescovent.com                        
                            </p>
                            <p className="text-start text-muted" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                +6012-211 7105
                            </p>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-4">
                                <h5 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                    Technology & IT Solutions
                                </h5>
                                <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                    Our technology firm specializes in delivering custom software, enterprise infrastructure, and cybersecurity solutions tailored to modern businesses.
                                </p>
                            </div>
                            <div className="col-md-4">
                                <h5 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                    Consulting & Strategy
                                </h5>
                                <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                    Our consulting firm helps clients streamline operations, optimize efficiency, and implement digital transformation strategies across industries.
                                </p>
                            </div>
                            <div className="col-md-4">
                                <h5 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                    Maintenance & Support
                                </h5>
                                <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                    We provide proactive IT maintenance, managed services, and ongoing support to ensure seamless business operations.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-4">
                        <div className="card shadow">
                            <div className="card-header bg-white border-0">
                                <h3 className="mb-0 mt-2 text-start" style={{
                                    fontFamily: 'Avenir, sans-serif',
                                    fontWeight: 'bold'
                                }}>Get In Touch</h3>
                            </div>
                            <div className="card-body">
                                <form className="mt-2" onSubmit={handleSubmit}>
                                    <div className="mb-2">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control rounded-0"
                                            placeholder="Your Name"
                                            required
                                            style={{
                                                height: '50px',
                                                fontFamily: 'Avenir, sans-serif'
                                            }}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <input
                                            type="tel"
                                            name="phone"
                                            className="form-control rounded-0"
                                            placeholder="Phone Number"
                                            required
                                            style={{
                                                height: '50px',
                                                fontFamily: 'Avenir, sans-serif'
                                            }}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control rounded-0"
                                            placeholder="Email Address"
                                            required
                                            style={{
                                                height: '50px',
                                                fontFamily: 'Avenir, sans-serif'
                                            }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <textarea
                                            name="message"
                                            className="form-control rounded-0"
                                            rows="4"
                                            placeholder="Your Message"
                                            required
                                            style={{
                                                fontFamily: 'Avenir, sans-serif'
                                            }}
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn px-4 rounded-0"
                                        style={{
                                            backgroundColor: submitStatus.color,
                                            color: 'white',
                                            width: '100%',
                                            height: '50px',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}
                                    >
                                        {submitStatus.text}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Services Section */}
            <div className="container-fluid px-4 px-md-5 py-5">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-md-5">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.6223891621034!2d101.63461267497028!3d2.924421097051927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cdb6dd0abaf673%3A0x6c38cacb901cb043!2sParagon%20%40%20Pan&#39;gaea!5e0!3m2!1sen!2smy!4v1741602036088!5m2!1sen!2smy"
                            width="100%"
                            height="400"
                            style={{ border: 0, borderRadius: '10px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Cresco Ventures Location"
                        ></iframe>
                    </div>
                    <div className="col-12 col-md-5">
                        <h1 className="display-4 text-start mb-0"
                            style={{
                                ...gradientTextStyle,
                                fontFamily: 'Godber, sans-serif',
                                fontSize: '60px'
                            }}>
                            Our Location
                        </h1>
                        <h2 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '36px', fontWeight: 'bold' }}>
                            We are here
                        </h2>
                        <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                            <span className='text-muted' style={{ fontWeight: 'bold' }}>CRESCO VENTURES SDN BHD (1555807-K)</span>
                            <br />
                            Unit SB-09-07, Paragon Tower,
                            <br />
                            Persiaran Bestari, Cyber 11,
                            <br />
                            63000 Cyberjaya, Selangor.
                        </p>
                        <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                            <span className='text-muted' style={{ fontWeight: 'bold' }}>Monday – Friday: </span>9:00 AM – 6:00 PM
                            <br />
                            <span className='text-muted' style={{ fontWeight: 'bold' }}>Saturday – Sunday: </span>Closed
                        </p>
                        <p className="text-start text-muted mt-3" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                            For urgent support or inquiries outside business hours, please contact our 24/7 support team or submit a request, and we'll get back to you as soon as possible.
                        </p>
                    </div>
                </div>
            </div>


            {/* Services Section */}
            <div className="container-fluid px-4 px-md-5 py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h1 className="display-4 text-start mb-0"
                            style={{
                                ...gradientTextStyle,
                                fontFamily: 'Godber, sans-serif',
                                fontSize: '40px'
                            }}>
                            Our Services
                        </h1>
                        <div className="row d-flex align-items-center justify-content-between mb-4">
                            <div className="col-auto">
                                <h2 className="mb-2 text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '36px', fontWeight: 'bold' }}>
                                    Tech-Driven, Future Ready
                                </h2>
                            </div>
                            <div className="col-auto">
                                <button className="btn rounded-0"
                                    onClick={() => window.location.href = '/services'}
                                    style={{
                                        width: '200px',
                                        height: '56px',
                                        backgroundColor: '#BC2025',
                                        color: 'white',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        fontFamily: 'Avenir, sans-serif'
                                    }}>
                                    <span className="me-3">Our Services</span>
                                    <i className="bi bi-arrow-up-right" style={{ fontWeight: 'bold' }}></i>
                                </button>
                            </div>
                        </div>

                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-2">
                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Digital Transformation</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Server Hardware)</span>
                                        </span>
                                        <img src="/services/digitalTransformation.png" alt="Server Hardware" className="img-fluid" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Data Center Solutions</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Cloud Infrastructure Solutions</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Virtualization & Compute Solutions</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Enterprise Solutions</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span>(System Integration)</span>
                                        </span>
                                        <img src="/services/systemIntegration.png" alt="Server Hardware" className="img-fluid" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>ERP & CRM Integration</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>IT Infrastructure Integration</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Cybersecurity Integration</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Software Development</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span>(Custom Applications)</span>
                                        </span>
                                        <img src="/services/customApplications.png" alt="Server Hardware" className="img-fluid" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Business Process Automation</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>AI & Data Analytics Platforms</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Mobile & Web Application Development</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Maintained & Support</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                            <span>(Managed Services)</span>
                                        </span>
                                        <img src="/services/manageService.png" alt="Server Hardware" className="img-fluid" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />

                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>24/7 IT Support & Monitoring </span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Backup & Disaster Recovery</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span className='text-danger'>Software Updates & Patch Management</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs; 